import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import * as edit from 'react-edit';
import EditPencil from '@elliemae/ds-icons/EditPencil';
import { cx } from '@elliemae/ds-utilities/utils';
import { appendCellFormatter } from '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import getEditorComponent from './getEditorComponent.js';
import '@babel/runtime/helpers/esm/extends';
import './EditableComponents/ComboBox.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@elliemae/ds-basic/form/ComboBox';
import './EditableComponents/TextBox.js';
import '@elliemae/ds-basic/form/TextBox';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var makeEditableConfig = function makeEditableConfig(grid) {
  return edit.edit({
    isEditing: function isEditing(_ref) {
      var columnIndex = _ref.columnIndex,
          rowData = _ref.rowData,
          _ref$column = _ref.column,
          column = _ref$column === void 0 ? {} : _ref$column,
          rest = _objectWithoutProperties(_ref, ["columnIndex", "rowData", "column"]);

      var _grid$getInstance = grid.getInstance(),
          editingRows = _grid$getInstance.state.editingRows,
          rowKey = _grid$getInstance.props.rowKey;

      var isCustomEditing;

      if (typeof column.isEditing === 'function') {
        isCustomEditing = column.isEditing(_objectSpread({
          columnIndex: columnIndex,
          rowData: rowData,
          column: column
        }, rest));
      }

      return editingRows[rowData[rowKey]] === columnIndex || column.alwaysEditing || isCustomEditing;
    },
    onActivate: function onActivate() {
      return null;
    },
    onValue: function onValue() {
      var _grid$getInstance$act;

      return (_grid$getInstance$act = grid.getInstance().actions).editValue.apply(_grid$getInstance$act, arguments);
    }
  });
};

var addEditableToCell = function addEditableToCell(_ref2, grid) {
  var column = _ref2.column,
      config = _ref2.config,
      handlers = _ref2.handlers;
  column.cell.transforms.push(config(getEditorComponent(column.customEditor, handlers)));
  column.cell.props.className = cx(column.cell.props.className, "editable".concat(column.customEditor ? ' customEditor' : ''));
  return appendCellFormatter([function (value, extraParams) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        e.stopPropagation();
        grid.getInstance().actions.activateEdit(extraParams);
      },
      onKeyUp: function onKeyUp(e) {
        e.stopPropagation();

        if (e.keyCode === 33) {
          grid.getInstance().actions.activateEdit(extraParams);
        }
      },
      role: "gridcell",
      tabIndex: 0
    }, value, /*#__PURE__*/React.createElement(EditPencil, {
      className: "edit-pencil"
    }), /*#__PURE__*/React.createElement("span", {
      className: "edit-separator"
    }, " ")));
  }], column);
};

export { addEditableToCell, makeEditableConfig };
//# sourceMappingURL=decorateEditable.js.map
